<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v">CONTENTS</a></h2><a id="page_v">
</a><p class="toc1"><a id="page_v"></a><a href="#/xhtml/prelude">Prelude <em>Science, Magic and the Prehistory of the Big Four</em></a></p>
<p class="tocpart"><a href="#/xhtml/ch01">1            Introduction</a></p>
<p class="tocpart"><a href="#/xhtml/part01"><strong>PART    I INFANCY</strong></a></p>
<p class="toc"><a href="#/xhtml/ch02">2 Glory, Not Infamy<br/>The Medici Bank as a precursor to the Big Four</a></p>
<p class="toc"><span href="#/xhtml/ch03" title="Link target outside of Sample">3 Transported<br/>How the Big Four began in the dangerous world of nineteenth-century accountancy</span></p>
<p class="toc"><span href="#/xhtml/ch04" title="Link target outside of Sample">4 A Curious Match<br/>The remarkable founders of the Big Four</span></p>
<p class="tocpart"><span href="#/xhtml/part02" title="Link target outside of Sample"><strong>PART   II MATURITY</strong></span></p>
<p class="toc"><span href="#/xhtml/ch05" title="Link target outside of Sample">5 Mere Automata<br/>Staking out the Big Four’s turf</span></p>
<p class="toc"><span href="#/xhtml/ch06" title="Link target outside of Sample">6 An Injudicious Change<br/>Adventures and misadventures in Big Four branding</span></p>
<p class="toc"><span href="#/xhtml/ch07" title="Link target outside of Sample">7 Porn Star<br/>The culture of the Big Four</span></p>
<p class="toc"><span href="#/xhtml/ch08" title="Link target outside of Sample">8 The Most Average Guys in the Room<br/>Big Four professional values</span><a id="page_vi"></a></p><a id="page_vi">
</a><p class="tocpart"><a id="page_vi"></a><span href="#/xhtml/part03" title="Link target outside of Sample"><strong>PART  III THE DIFFICULTIES OF ADULTHOOD</strong></span></p>
<p class="toc"><span href="#/xhtml/ch09" title="Link target outside of Sample">9 Unqualified<br/>Auditing as the foundation of the Big Four brands</span></p>
<p class="toca"><span href="#/xhtml/ch10" title="Link target outside of Sample">10 Clean<br/>The impairment of Big Four auditing</span></p>
<p class="toca"><span href="#/xhtml/ch11" title="Link target outside of Sample">11 Get Ready to Dance<br/>Conflicting interests in Big Four taxation services</span></p>
<p class="toca"><span href="#/xhtml/ch12" title="Link target outside of Sample">12 One Four Ten<br/>The Big Four in China</span></p>
<p class="tocpart"><span href="#/xhtml/part04" title="Link target outside of Sample"><strong>PART  IV THE TWILIGHT YEARS</strong></span></p>
<p class="toca"><span href="#/xhtml/ch13" title="Link target outside of Sample">13 Disrupted<br/>The obsolescence of Big Four technology</span></p>
<p class="toca"><span href="#/xhtml/ch14" title="Link target outside of Sample">14 Conclusion</span></p>
<p class="tocb"><span href="#/xhtml/epilogue" title="Link target outside of Sample"><em>Epilogue</em></span></p>
<p class="tocba"><span href="#/xhtml/ack" title="Link target outside of Sample"><em>Acknowledgements</em></span></p>
<p class="tocba"><span href="#/xhtml/endnotes" title="Link target outside of Sample"><em>Endnotes</em></span></p>
<p class="tocba"><span href="#/xhtml/bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="tocba"><span href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="tocba"><span href="#/xhtml/authors" title="Link target outside of Sample"><em>About the Authors</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0b78c392